<ng-container *transloco="let t">
  <div infinite-scroll
       [infiniteScrollDistance]="1"
       (scrolled)="scrolled.emit()"
       class="row row-cols-1 row-cols-md-2 row-cols-lg-1">
      @for (item of leagues; track item.id; let i = $index, first = $first) {
        @if (first && item.status !== LeagueStatus.FINISHED) {
            <div class="pt-20">
                <p class="fs-16 fw-600 color-slate-800 mb-2"> {{ t('league.upcoming') | uppercase }} </p>
            </div>
        }
        @if (first && item.status === LeagueStatus.FINISHED) {
            <div class="pt-20">
                <p class="fs-16 fw-600 color-slate-800 mb-2"> {{ t('league.finished') | uppercase }} </p>
            </div>
        }

        <div class="py-10">
            <app-league-grid-item
            [league]="item"
            [languages]="languages"
            (onRightButtonClickCallback)="onRightButtonClickCallback.emit(item)"/>
        </div>

        @if (item.status !== LeagueStatus.FINISHED && leagues[i + 1]?.status === LeagueStatus.FINISHED) {
            <div class="pt-20">
                <p class="fs-16 fw-600 color-slate-800 mb-2"> {{ t('league.finished') | uppercase }} </p>
            </div>
        }
    }
  </div>
</ng-container>